module.exports = __webpack_public_path__ + "media/images/team/MariaCristinaCanavarro-1ea24e32fa46e33890d9b8cad7d33f6e.png";